module.exports = __webpack_public_path__ + "img/4.9d9c7fd7.png";